import { Event } from '@sentry/vue'
import { SENTRY_MODULES } from '../common'
import { extractFederatedAppMeta } from '../utils'
export const conditionalProfiling = (event: Event) => {
  if (event?.tags?.module === SENTRY_MODULES.SPM_TS) {
    return event
  }
  const federatedAppInfo = extractFederatedAppMeta(event)

  if (federatedAppInfo) {
    if (federatedAppInfo?.[0]?.module === SENTRY_MODULES.CONVERSATIONS_APP) {
      return event
    }
  }

  return null
}
